import { render, staticRenderFns } from "./SupplierOnboardingFiscalProfile.vue?vue&type=template&id=5b0a491f&"
import script from "./SupplierOnboardingFiscalProfile.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingFiscalProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports